/*
// KJR 2014-08-22
// Global JS included on every page.  Add all your common script inits here.
*/

//$(document).ready(function() {
	$(function() { // Shorthand for $( document ).ready()
		// executes when HTML-Document is loaded and DOM is ready
	
		//fix for Windows Phone 8
		if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
			var msViewportStyle = document.createElement('style');
			msViewportStyle.appendChild(
				document.createTextNode(
					'@-ms-viewport{width:auto!important}'
				)
			);
			document.querySelector('head').appendChild(msViewportStyle);
		}
	
		//menu toggle
		$("#menu").click(function() {
			$('#main-nav').toggleClass("block");
		});
	
		//animate the scroll to top
		addScrollToOnClick('.back2top', 'body', 500);
	
		//Check for dropdowns when mobile menu toggle is visible then disable the anchor link for the parent li
		$("#main-nav > li > a").click(function() {
			try {
				if ($(this).parent().hasClass("has-children") && $("#menu").is(":visible")) {
					return false;
				}
			} catch (e) {
				//console.log(e);
				return false;
			}
		});
	
		//search box dropout effect
		$(".search").click(function() {
			$('.search-box').toggleClass("search-block");
		});
	
		//track phone number taps & clicks
		$('.tel').on('click', function(e){
			e.preventDefault();
			trackEvent('Mobile', 'Click to Call', $(this).data('tel'));
			window.location = 'tel:'+$(this).data('tel');
		});
	
	
		//decrypt encrypted mailto links
		$('.mailto').each(function() {
			var strEncrypted = $(this).html();
			var parts = strEncrypted.split("|");
			var email = rot13(decodeBase64(parts[0]));
			var display = rot13(decodeBase64(parts[1]));
			var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
			$(this).html(html);
		});
	
	}); //End document.ready
	
	window.onload = function() {
		// executes when complete page is fully loaded, including all frames, objects and images
	}; //End window.onload
	

	function trackEvent(category, action, label) {
		//EXAMPLES:
		//ga('send', 'event', 'Videos', 'Play', 'Gone With the Wind']);
		//ga('send', 'event', 'Videos', 'Downloaded', 'Gone With the Wind']);
		//ga('send', 'event', 'Downloads', 'PDF', 'Expense Report']);
		//ga('send', 'event', 'datasheet-download', 'click', 'http://www.myurl.com');
		if (typeof ga !== 'undefined') {
			//ga('send', 'event', category, action, label);
			gtag('event', action, {
				// Event parameters
				'event_category': category,
				'event_label': label
			});
		} else {
			console.log('Simulating GA event tracking: category = "'+category+'", action = "'+action+'", label = "'+label+'"');
		}
	}
	
	function addScrollToOnClick(clickedElm, targetElm, animationDuration) {
		$(clickedElm).click(function(event) {
			event.preventDefault();
			$('html, body').animate({scrollTop: $(targetElm).offset().top}, animationDuration);
			return false;
		});
	}
	
	function getScrollbarWidth() {
		var outer = document.createElement("div");
		outer.style.visibility = "hidden";
		outer.style.width = "100px";
		document.body.appendChild(outer);
	
		var widthNoScroll = outer.offsetWidth;
		// force scrollbars
		outer.style.overflow = "scroll";
	
		// add innerdiv
		var inner = document.createElement("div");
		inner.style.width = "100%";
		outer.appendChild(inner);
	
		var widthWithScroll = inner.offsetWidth;
	
		// remove divs
		outer.parentNode.removeChild(outer);
	
		return widthNoScroll - widthWithScroll;
	}

	function html5FormCompatibility() {
		$(function() {
			if (!Modernizr.formvalidation) {
				//console.log('no formvalidation');
				$.when(
					$.getCSS({ href: "css/jquery.qtip.min.css", media: "screen" }),
					$.getScript( "js/jquery.qtip.min.js" ),
					$.getScript( "js/nwxforms.js" ),
					$.Deferred(function( deferred ){
						$( deferred.resolve );
					})
				).done(function(){
					//the scripts are all loaded
					nwxforms(window);
				});
			}
			if (!Modernizr.inputtypes.date) {
				//load jquery ui and instantiate datepicker
				$.when(
					$.getCSS({ href: "js/jquery-ui-1.11.4/jquery-ui.min.css", media: "screen" }),
					$.getScript( "js/jquery-ui-1.11.4/jquery-ui.min.js" ),
					$.Deferred(function( deferred ){
						$( deferred.resolve );
					})
				).done(function(){
					//the scripts are all loaded
					$( "input[type='date']" ).datepicker();
				});
			}
		});
	}
	
	/*
	 * jQuery getCSS Plugin
	 * Copyright 2013, intesso
	 * MIT license.
	 *
	 * cross browser function to dynamically load an external css file.
	 * see: [github page](http://intesso.github.com/jquery-getCSS/)
	 *
	 */
	
	(function() {
		/*
			arguments: attributes
			attributes can be a string: then it goes directly inside the href attribute.
			e.g.: $.getCSS("fresh.css")
			attributes can also be an objcet.
			e.g.: $.getCSS({href:"cool.css", media:"print"})
			or:	$.getCSS({href:"/styles/forest.css", media:"screen"})
		*/
		var getCSS = function(attributes) {
				// setting default attributes
				if(typeof attributes === "string") {
					var href = attributes;
					attributes = {
						href: href
					};
				}
				if(!attributes.rel) {
					attributes.rel = "stylesheet";
				}
				// appending the stylesheet
				// no jQuery stuff here, just plain dom manipulations
				var styleSheet = document.createElement("link");
				for(var key in attributes) {
					styleSheet.setAttribute(key, attributes[key]);
				}
				var head = document.getElementsByTagName("head")[0];
				head.appendChild(styleSheet);
			};
	
		if(typeof jQuery === "undefined") {
			window.getCSS = getCSS;
		} else {
			jQuery.getCSS = getCSS;
		}
	
	})();